import { gql } from "@apollo/client";

// Takes the exact same arguments as the delete mutation and runs the same
// evaluator server-side, so its effect/blocking answer cannot be contradicted
// by the mutation afterwards. Re-run whenever the dialog arguments change.
export const DeleteInstalledBaseNodePreview = gql`
    query DeleteInstalledBaseNodePreview ($id: ID!, $deleteSubNodes: Boolean, $targetParentInstalledBaseNodeId: ID) {
        deleteInstalledBaseNodePreview (
            id: $id
            deleteSubNodes: $deleteSubNodes
            targetParentInstalledBaseNodeId: $targetParentInstalledBaseNodeId
        ) {
            allowed
            effect
            blockingReasons
            installedAssetCount
        }
    }
`;
